import View from './views/View'

const route = {
    exact: true,
    purePath: '/checkout',
    path: '/:lang/checkout',
    component: View
}

export default route